module.exports = __webpack_public_path__ + "static/media/bright_planets.d9c8f8d5.png";